import { Link } from 'react-router-dom';

const footerNav = [
  {
    title: '内容',
    links: [
      { label: '分集剧情', path: '/category/plot' },
      { label: '演员名单', path: '/category/cast' },
      { label: '最新动态', path: '/category/news' },
    ],
  },
  {
    title: '专题',
    links: [
      { label: '人物关系梳理', path: '/detail/news/7' },
      { label: '幕后制作', path: '/detail/news/3' },
      { label: '主创访谈', path: '/detail/news/2' },
    ],
  },
  {
    title: '站点',
    links: [
      { label: '关于本站', path: '/about' },
      { label: '版权申明', path: '/about' },
      { label: '使用条款', path: '/about' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-auto bg-primary-950 text-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 font-heading text-lg text-primary-950">
                禁
              </span>
              <div>
                <p className="font-heading text-lg text-background-50">禁止的爱善良的小姨子</p>
                <p className="mt-1 text-[10px] tracking-[0.3em] text-background-100/50">
                  FORBIDDEN LOVE · DRAMA ARCHIVE
                </p>
              </div>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-background-100/70">
              本站是电视剧《禁止的爱善良的小姨子》的非官方资料整理专题，收录分集剧情、演员资料与幕后动态，
              便于观众在追剧之余回看细节、理解人物。站内不提供视频播放与下载服务。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {['剧情档案', '演员资料', '幕后动态', '专题策划'].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-background-100/20 px-3 py-1 text-xs text-background-100/70"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {footerNav.map((group) => (
            <div key={group.title} className="lg:col-span-2">
              <h4 className="font-heading text-sm text-accent-300">
                <span>{group.title}</span>
              </h4>
              <ul className="mt-4 space-y-3">
                {group.links.map((link) => (
                  <li key={`${group.title}-${link.label}`}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-100/70 transition-colors hover:text-background-50"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-1">
            <h4 className="font-heading text-sm text-accent-300">
              <span>联系</span>
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-background-100/70">
              <li className="whitespace-nowrap">编辑信箱</li>
              <li className="break-all text-xs">editor@forbidden-love.example</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-100/15 pt-6 text-xs text-background-100/50 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 禁止的爱善良的小姨子专题站 · 内容仅用于剧集资料展示与交流</p>
          <p className="whitespace-nowrap">站内剧照与人物信息均为演示内容</p>
        </div>
      </div>
    </footer>
  );
}